
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import Pagebanner from "../../layout/Banner";
import ContactForm from "../../Components/HomeSections/ContactForm";
import { Helmet } from "react-helmet-async";


const ContactUS = () => {
  const brandGold = "#E3B66B";
  const darkGreen = "#0A1D1B";
  return (
    <>
      <Helmet>
        <title>Contact SKS Law Groups & Associates | Legal Consultation</title>
        <meta
          name="description"
          content="Contact SKS Law Groups & Associates for expert legal advice and consultation. Connect with experienced lawyers for prompt assistance."
        />
        <meta
          name="keywords"
          content="Contact Shailendra Kumar Singh, Legal Consultation, Law Firm Contact, Lawyer Inquiry, Legal Services Contact"
        />
        <link rel="canonical" href="https://skslawgroupsandassociates.com/contact-us" />
        <noscript>
          Please enable JavaScript to view this website properly.
        </noscript>
      </Helmet>

      <Header />
      <Pagebanner title="Contact Us" />
      <ContactForm />

      {/* Map Section */}
      <section className={`bg-[${darkGreen}] py-12 px-6 md:px-12`}>
        <div
          className="max-w-7xl mx-auto rounded-lg overflow-hidden shadow-lg border-2"
          style={{ borderColor: brandGold }}
        >
          <iframe
            title="Shailendra Kumar Singh Chambers Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2871.8556325505892!2d77.22130750354043!3d28.529014858032767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce1e4ae30ba5f%3A0xadbfebbb6902add4!2sAdv.%20Shailendra%20Kumar%20Singh%2C%20Criminal%20Lawyer!5e0!3m2!1sen!2sin!4v1774251393131!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ContactUS;

